import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "svg-icon svg-icon-1 position-absolute ms-6 my-3" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search fs-4 me-2" }, null, -1)
const _hoisted_13 = { class: "card-body pt-0" }
const _hoisted_14 = {
  key: 0,
  class: "badge badge-warning"
}
const _hoisted_15 = {
  key: 1,
  class: "badge badge-success"
}
const _hoisted_16 = {
  key: 2,
  class: "badge badge-danger"
}
const _hoisted_17 = { class: "text-white" }
const _hoisted_18 = {
  key: 0,
  class: "text-success"
}
const _hoisted_19 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_20 = { key: 2 }
const _hoisted_21 = {
  key: 0,
  class: "badge badge-warning"
}
const _hoisted_22 = {
  key: 1,
  class: "badge badge-success"
}
const _hoisted_23 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_DateRangePicker = _resolveComponent("DateRangePicker")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.search.username = $event)),
              class: "form-control form-control-solid w-250px ps-15",
              placeholder: _ctx.$t('Members.SearchID')
            }, null, 8, _hoisted_7), [
              [_vModelText, _ctx.search.username]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_el_select, {
              modelValue: _ctx.search.game,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.search.game = $event)),
              class: "bg-body"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.games, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_select, {
              modelValue: _ctx.search.state,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.search.state = $event)),
              class: "bg-body"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.states, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_DateRangePicker, { onChangedate: _ctx.setSelectedDate }, null, 8, ["onChangedate"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              href: "#",
              class: "btn btn-primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getHistory()))
            }, [
              _hoisted_12,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("MoneyTransfer.Search")), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_Datatable, {
        "table-data": _ctx.tableData,
        "table-header": _ctx.tableHeader,
        "enable-items-per-page-dropdown": true,
        "rows-per-page": 50,
        total: _ctx.rowsCount,
        onItemsPerPageChange: _ctx.setPageLimit,
        onCurrentChange: _ctx.setPage
      }, {
        "cell-agent": _withCtx(({ row: history }) => [
          _createTextVNode(_toDisplayString(history.agent_name) + " (" + _toDisplayString(history.agent_code) + ") ", 1)
        ]),
        "cell-state": _withCtx(({ row: history }) => [
          (history.state === 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t("BetHistory.Pending")), 1))
            : _createCommentVNode("", true),
          (history.state === 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$t("BetHistory.Completed")), 1))
            : _createCommentVNode("", true),
          (history.state === 2)
            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$t("BetHistory.Cancelled")), 1))
            : _createCommentVNode("", true)
        ]),
        "cell-betposition": _withCtx(({ row: history }) => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("Betposition." + history.betposition)), 1)
        ]),
        "cell-betamount": _withCtx(({ row: history }) => [
          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$n(Number(history.betamount))), 1)
        ]),
        "cell-winamount": _withCtx(({ row: history }) => [
          (
              Number(history.winamount) - Number(history.betamount) >= 0 &&
              history.state > 0
            )
            ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$n(Number(history.winamount) - Number(history.betamount))), 1))
            : (
              Number(history.winamount) - Number(history.betamount) < 0 &&
              history.state > 0
            )
              ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$n(Number(history.winamount) - Number(history.betamount))), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_20, " - "))
        ]),
        "cell-command": _withCtx(({ row: history }) => [
          (history.command === 'BET')
            ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(history.command), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(history.command), 1))
        ]),
        "cell-detail": _withCtx(({ row: history }) => [
          _createElementVNode("a", {
            target: "_blank",
            href: `/results/${history.history_id}`,
            class: "btn btn-secondary"
          }, _toDisplayString(_ctx.$t("ApiManual.DetailInfo")), 9, _hoisted_23)
        ]),
        _: 1
      }, 8, ["table-data", "table-header", "total", "onItemsPerPageChange", "onCurrentChange"])
    ])
  ]))
}